module.exports = __webpack_public_path__ + "img/strategy.5e1219d4.png";